import { connect } from "knockout-store";
import axios from "axios";
import storylineJs, {
  refresh,
  scrollToParagraph,
  toDesktop,
} from "./storyline";
import carouselJs, {
  toggleCard,
  slideTo,
  slideCarouselToNextPart,
  slideCarouselToPrevPart,
  bounceCarousel,
  fillMobileCounter,
} from "./carousel";
import { toggleModal } from "../../utils/modal";
import { initMap, updateMarkers, drawPolyLine, reInitMap } from "./map";
import glossaryJs from "./glossary";
import galleryJs, { inlineEvidence } from "./gallery";
import {
  datamodelForSlides,
  getPartChapterParagraphBy,
  getSpecificStoryLineData,
} from "../../utils/content";
import { getMobileIndex } from "../../utils/functions";
import { getParagraphsForRoute } from "../../utils/content";
import ko from "knockout";
import { t } from "../../utils/translations";
import { r } from "../../utils/routing";

function initCustomHandlers(params) {
  ko.bindingHandlers["drag"] = {
    init: function (element, valueAccessor) {
      const hammertime = new Hammer(element, { touchAction: "auto" }); // Set to auto because of iOS scrolling issue with default value. #20829
      hammertime.get("swipe").set({ direction: Hammer.DIRECTION_ALL });

      // Swipe next
      hammertime.on("swipeleft", function (e) {
        if (params.isMobile()) {
          slideTo(
            true,
            params.mobileSlidesPosition(),
            params.mobileSlides(),
            (value) => {
              params.mobileSlidesPosition(value);
            },
            (value) => {
              params.currentParagraphID(value);
            }
          );
        }
      });

      // Swipe prev
      hammertime.on("swiperight", function (e) {
        if (params.isMobile()) {
          slideTo(
            false,
            params.mobileSlidesPosition(),
            params.mobileSlides(),
            (value) => {
              params.mobileSlidesPosition(value);
            },
            (value) => {
              params.currentParagraphID(value);
            }
          );
        }
      });

      // Swipe up
      hammertime.on("swipeup", function (e) {
        if (params.isMobile()) {
          toggleCard(e);
        }
      });
    },
  };
}

function storyLineViewModel(params) {
  function check(value) {
    if (params.route() === r("storyline") && !params.storylineDataLoading()) {
      params.storylineDataLoading(true);

      Promise.all([
        axios.get(
          `${process.env.CONTENT_URL}/${process.env.LANGUAGE}_${process.env.STORY_LINE}.json`
        ),
        axios.get(
          `${process.env.CONTENT_URL}/${process.env.LANGUAGE}_${process.env.GLOSSARY}.json`
        ),
      ])
        .then(([storyline, glossary]) => [storyline.data, glossary.data])
        .then(([storyline, glossary]) => {
          params.storylineData(storyline);
          params.mobileSlides(datamodelForSlides(storyline));
          params.mobileSlidesPosition(0);
          params.glossaryData(glossary);
          vm.dataLoading(false);
        });
    }
  }

  params.route.subscribe(function (newValue) {
    if (newValue === r("storyline")) {
      setTimeout(() => {
        reInitMap();
      }, 0);
    }
    check(newValue);
  });

  params.mobileSlidesPosition.subscribe(function (value) {
    if (params.isMobile()) {
      setTimeout(() => {
        carouselJs(value, params.mobileSlides(), params.mobileSlidesPosition);
      }, 0);
    }
  });

  params.storylineData.subscribe(function () {
    setTimeout(() => {
      bounceCarousel();
      storylineJs(
        params.currentPartID(),
        (value) => {
          if (value !== params.currentParagraphID()) {
            params.currentParagraphID(value);
          }
        },
        (value) => {
          params.currentChapterID(value);
        },
        params.isMobile()
      );
      glossaryJs((value) => {
        params.glossaryID(value);
        params.popUp("glossary");
      });
      galleryJs((currentEvidenceID, galleryID) => {
        params.currentEvidenceID(parseInt(currentEvidenceID));
        params.galleryID(galleryID);
        params.modal("gallery");
      });
      inlineEvidence((currentEvidenceID, galleryID) => {
        params.currentEvidenceID(parseInt(currentEvidenceID));
        params.galleryID(galleryID);
        params.modal("gallery");
      });
      initMap(params.isMobile());
    }, 0);
  });

  params.currentParagraphID.subscribe(function (value) {
    setTimeout(() => {
      if (value !== undefined) {
        let paragraph = getSpecificStoryLineData(
          value,
          "paragraph",
          params.storylineData()
        );
        updateMarkers(
          paragraph.markers,
          paragraph.zoom_level,
          paragraph.custom_center,
          value,
          params.isMobile()
        );
        drawPolyLine(
          getParagraphsForRoute(params.currentPartID(), params.storylineData()),
          paragraph.id,
          paragraph.polylines,
          paragraph.index
        );
      }
    }, 0);
  });

  params.isMobile.subscribe(function (value) {
    if (value === false) {
      // Is desktop
      toDesktop(
        params.currentPartID(),
        params.currentChapterID(),
        params.currentParagraphID()
      );
    } else {
      // Is mobile
      //disableScrollTriggers();
      params.mobileSlidesPosition(
        getMobileIndex(
          params.mobileSlides(),
          params.currentParagraphID() ?? params.currentChapterID()
        )
      );
    }
  });

  check(params.route());

  const vm = {};
  vm.visible = () => params.route() === r("storyline");
  vm.data = () => params.storylineData;
  vm.translation = (key) => t(key);
  vm.dataLoading = ko.observable(true);
  vm.isActivePart = (id) => params.currentPartID() === id;
  vm.isActiveChapter = (id) => params.currentChapterID() === id;
  vm.isActiveParagraph = (id) => params.currentParagraphID() === id;
  vm.isParagraphAfterChapter = (index) => index === 0;
  vm.openGallery = (currentEvidenceID, paragraphID) => {
    toggleModal("gallery", params.route(), (value) => {
      params.galleryID(paragraphID);
      params.currentEvidenceID(currentEvidenceID);
      params.modal(value);
    });
  };
  vm.getFirstParagraphName = (paragraphs) => {
    return paragraphs.length > 0 ? "mother_" + paragraphs[0].paragraph_id : "";
  };
  vm.hasPrevious = (index) => {
    return index() !== 0;
  };
  vm.hasNext = (index) => {
    return params.storylineData().length - 1 !== index();
  };
  vm.setNext = (index) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    const { id, chapter_id, paragraph_id } = getPartChapterParagraphBy(
      params.storylineData()[index() + 1]
    );

    // track  current paragraph and chapter for desktop
    // TODO: Check if mobile condition should be here.
    // Should it not always set the current paragraph and chapter for when we want to scale to desktop view?
    if (params.isMobile() === false) {
      params.currentParagraphID(paragraph_id);
      params.currentChapterID(chapter_id);
    }
    params.currentPartID(id);
    refresh(id, paragraph_id, true, true);

    // slide to correct part on mobile
    if (params.isMobile()) {
      slideCarouselToNextPart(params.mobileSlidesPosition(), (value) => {
        params.mobileSlidesPosition(value);
      });
    }
  };
  vm.setPrevious = (index) => {
    window.scrollTo({
      top: 0,
      left: 0,
      behavior: "instant",
    });

    const { id, chapter_id, paragraph_id } = getPartChapterParagraphBy(
      params.storylineData()[index() - 1]
    );

    // track current paragraph and chapter for desktop
    if (params.isMobile() === false) {
      params.currentParagraphID(paragraph_id);
      params.currentChapterID(chapter_id);
    }
    params.currentPartID(id);

    refresh(id, paragraph_id, true, true);

    // slide to correct part on mobile
    if (params.isMobile()) {
      slideCarouselToPrevPart(index(), params.mobileSlides(), (value) => {
        params.mobileSlidesPosition(value);
      });
    }
  };
  vm.openIndex = (event) => {
    event.preventDefault();
    toggleModal("index", params.route(), (value) => {
      params.modal(value);
    });
  };
  vm.mobileArrow = (isNext) => {
    slideTo(
      isNext,
      params.mobileSlidesPosition(),
      params.mobileSlides(),
      (value) => {
        params.mobileSlidesPosition(value);
      },
      (value) => {
        params.currentParagraphID(value);
      }
    );
  };
  vm.mobileData = () => {
    return params.mobileSlides;
  };
  vm.getCurrentMobileSlideID = (id) => {
    return getMobileIndex(params.mobileSlides(), id);
  };
  vm.showSlide = (id) => {
    if (
      params.mobileSlidesPosition() ===
      getMobileIndex(params.mobileSlides(), id)
    ) {
      return true;
    }
  };
  vm.mobileCounter = () => {
    return fillMobileCounter(
      params.mobileSlides(),
      params.mobileSlidesPosition()
    );
  };
  vm.scrollToParagraph = (paragraphID, e) => {
    scrollToParagraph(paragraphID, e);
  };
  vm.tooltipMetaData = (date, time) => {
    if (time) {
      return `${date} : ${time}`;
    } else {
      return `${date}`;
    }
  };

  initCustomHandlers(params);

  return vm;
}

function mapStateToParams({
  route,
  modal,
  popUp,
  storylineDataLoading,
  storylineData,
  glossaryData,
  currentPartID,
  currentChapterID,
  currentParagraphID,
  currentEvidenceID,
  galleryID,
  glossaryID,
  mobileSlides,
  mobileSlidesPosition,
  isMobile,
}) {
  return {
    route,
    modal,
    popUp,
    storylineDataLoading,
    storylineData,
    glossaryData,
    currentPartID,
    currentChapterID,
    currentParagraphID,
    currentEvidenceID,
    galleryID,
    glossaryID,
    mobileSlides,
    mobileSlidesPosition,
    isMobile,
  };
}

export default connect(mapStateToParams)(storyLineViewModel);
